import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { handleError } from 'src/app/shared/functions/error-handler';
import { ApiResponse } from 'src/app/shared/interfaces/api-response';
import { AppConfigService } from '../../../services/app-config.service';
import { IAppConfig } from '../../../shared/interfaces/app-config';
import { CreateNewStudentLinkToParentModel } from '../../student-search/models/create-and-link-new-student-models/create-new-student-link-to-parent-model';
import { ParentGuardianRelationModel } from '../../student-search/models/student-search-interface';
import { StudentGuardiansRequest } from '../interfaces/verification-guardian-parent-child-interface';
import { ConfirmRequestModel } from '../models/confirm-verification-save.model';
import { ParentGuardianDetailsResponse } from '../models/parent-guardian-details-response.model';

@Injectable({
  providedIn: 'root',
})
export class VerificationGuardianParentChildService {
  config: IAppConfig;
  private http: HttpClient = inject(HttpClient);
  private appConfigService: AppConfigService = inject(AppConfigService);
  constructor() {
    this.config = this.appConfigService.getConfig();
  }

  public get(
    linkSk?: string
  ): Observable<ApiResponse<ParentGuardianDetailsResponse>> {
    return this.http
      .get<ApiResponse<ParentGuardianDetailsResponse>>(
        `${this.config.apiUrl}/LinkParentwithChildRelation/GetParentGuardianLinkDetails/` +
        linkSk
      )
      .pipe(catchError(handleError));
  }
  public getStudentGuardians(): Observable<StudentGuardiansRequest[]> {
    return this.http
      .get<StudentGuardiansRequest[]>(
        `${this.config.apiUrl}/ParentPortal/StudentGuardians`
      )
      .pipe(
        map((res: StudentGuardiansRequest[] | null) => res ?? []),
        catchError(handleError)
      );
  }
  public submit(request: ConfirmRequestModel): Observable<ConfirmRequestModel> {
    return this.http
      .post<ConfirmRequestModel>(
        `${this.config.apiUrl}/LinkParentwithChildRelation/ParentVerificationWithChildReject`,
        request
      )
      .pipe(catchError(handleError));
  }
  public addLinkParentwithChild(
    request: CreateNewStudentLinkToParentModel
  ): Observable<ApiResponse<ParentGuardianRelationModel>> {
    return this.http
      .post<ApiResponse<ParentGuardianRelationModel>>(
        `${this.config.apiUrl}/LinkParentwithChildRelation/AddLinkParentwithChild`,
        request
      )
      .pipe(catchError(handleError));
  }
}
